import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-6 px-0 sm:px-6 sm:shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "text-center text-2xl text-gray-800 sm:text-gray-600 font-header mb-8" }, " Reset Password ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Reset Paassword ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      valid: _ctx.valid,
      "onUpdate:valid": _cache[3] || (_cache[3] = $event => (_ctx.valid = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Input, {
          label: "New Password",
          type: "password",
          value: _ctx.form.password.value,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.password.value = $event)),
          rules: _ctx.form.password.rules
        }, null, 8, ["value", "rules"]),
        _createVNode(_component_Input, {
          label: "Confirm Password",
          type: "password",
          value: _ctx.form.confirm_password.value,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => (_ctx.form.confirm_password.value = $event)),
          rules: _ctx.form.confirm_password.rules
        }, null, 8, ["value", "rules"]),
        _createVNode(_component_Button, {
          "is-disabled": !_ctx.valid,
          color: "secondary"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["is-disabled"])
      ]),
      _: 1
    }, 8, ["valid"])
  ]))
}